import { workspaceActivitiesUrl } from '../urls';
import refresh from '../refresh';

export default async function getWorkspaceActivity(workspaceId) {
  return refresh(async () => {
    const response = await fetch(`${workspaceActivitiesUrl}?workspace=${workspaceId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
